<template>
  <page-layout
    :breadcrumbs="breadcrumbs"
    :title="promocion == null ? $t('pages.configuracion.configuracionGeneral') : $t('pages.configuracion.configuracion')+ ' ' + promocion.descripcion"
  >
  <o-main-progress v-if="loading"/>
  <div v-else>
    <v-expansion-panel  
      expand 
      v-model="expandGeneral"
    >
      <v-expansion-panel-content
        :key="'general'"
      >
        <v-icon slot="actions" color="primary">keyboard_arrow_down</v-icon>
        <div slot="header">
          <o-medium-title v-if="promocion == null">{{$t('pages.configuracion.configuracionGeneral')}}</o-medium-title>
          <o-medium-title v-else >{{$t('pages.configuracion.configuracion')}} {{ promocion.descripcion }}</o-medium-title>
        </div>
        <v-card>
          <v-container fluid>
            <v-form v-model="valid" ref="form">
              <v-layout column align-left px-4 v-if="promocion == null">
                <span class="grey--text v-label">
                  {{$t('configuracion.descripcionOTP')}}
                </span>
                <v-checkbox
                  :label="$t('pages.configuracion.otp')"
                  v-model="otp"
                  color="primary"
                  @change="cambiadoGeneral = true"
                />
              </v-layout>
              <v-layout column align-left px-4 v-if="promocion == null">
                <span class="grey--text v-label mb-3">
                  {{$t('configuracion.imagenCorreos')}}
                </span>
                <v-layout >
                  <v-flex shrink>
                    <FileUploader
                      style="height:168px; width: 200px"
                      :maxNum="1"
                      v-model="imagenCorreos"
                      :deletable="true"
                      accept="image/*"
                      :imagesOnly="true"
                    />
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-layout color="primary">
                <span class="primary--text" style="font-size:15px">{{$t('reservaSimplificada.inicioProcesoReservaTitulo')}}</span>
              </v-layout>
              <v-divider class="dividerTitle primary"></v-divider>
              <v-layout column align-left px-4 style="display:flex;flex-direction: row;">
                <v-checkbox 
                  v-model="iniciarVentaExt"
                  :label="$t('reservaSimplificada.inicioVentaExt')"
                  :style="iniciarVentaExt && promocion==null ? 'pointer-events:none': ''"
                  color="primary"
                />
                <v-checkbox 
                  v-model="iniciarVentaSimp"
                  :label="$t('reservaSimplificada.inicioVentaSimp')"
                  :style="iniciarVentaSimp && promocion==null ? 'pointer-events:none': ''"
                  color="primary"
                />
                <v-checkbox 
                  v-model="iniciarConPreguntaVenta"
                  :label="$t('reservaSimplificada.iniciarConPreguntaVenta')"
                  :style="iniciarConPreguntaVenta && promocion==null ? 'pointer-events:none': ''"
                  color="primary"
                />
              </v-layout>
              <v-layout column align-left px-4 style="display:flex;flex-direction: row;">
                <v-checkbox 
                  v-model="iniciarAlquilerExt"
                  :style="iniciarAlquilerExt && promocion==null ? 'pointer-events:none': ''"
                  :label="$t('reservaSimplificada.inicioAlquilerExt')"
                  color="primary"
                />
                <v-checkbox 
                  v-model="iniciarAlquilerSimp"
                  :style="iniciarAlquilerSimp && promocion==null ? 'pointer-events:none': ''"
                  :label="$t('reservaSimplificada.inicioAlquilerSimp')"
                  color="primary"
                />
                <v-checkbox 
                  v-model="iniciarConPreguntaAlquiler"
                  :style="iniciarConPreguntaAlquiler && promocion==null ? 'pointer-events:none': ''"
                  :label="$t('reservaSimplificada.iniciarConPreguntaAlquiler')"
                  color="primary"
                />
              </v-layout>
              <v-layout justify-center pt-2>
                <v-btn
                  large color="primary"
                  :disabled="!cambiadoGeneral || guardandoGeneral"
                  :loading="guardandoGeneral"
                  @click="guardarVariablesConfiguracion()"
                >
                    {{$t('pages.guardarCambios')}}
                </v-btn>
              </v-layout>
            </v-form>
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel 
      expand 
      v-model="expandVenta"
      class="mt-4"
    >
      <v-expansion-panel-content
        :key="'venta'"
      >
        <v-icon slot="actions" color="primary">keyboard_arrow_down</v-icon>
        <v-icon v-if="promocion && modulosOrdenStore.some(x => x.simplificada == 0 && !x.alquiler)" :loading="guardando" class="keep-icon-upright" slot="actions" color="primary" @click.stop="borrarConfiguracionPromo(false,'venta', false)">delete</v-icon>
        <div slot="header">
          <o-medium-title>{{$t('pages.configuracion.venta')}}</o-medium-title>
        </div>
        <v-card>
          <v-container fluid>
            <ConfiguracionReserva
              :codigoPromocion="promocion ? promocion.codigo : null"
              :alquiler="false"
              @cambiado="cambiadoVentaExt = $event"
              :borradoDeFuera="borradoVentaFueraExt"
              @resetBorrado="borradoVentaFueraExt = false"
            />
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel 
      expand 
      v-model="expandVentaSimplificada"
      class="mt-4"
    >
   
      <v-expansion-panel-content
        :key="'venta'"
      >
      
        <v-icon slot="actions" color="primary">keyboard_arrow_down</v-icon>
        <v-icon v-if="promocion && modulosOrdenStore.some(x => x.simplificada == 1 && !x.alquiler)" :loading="guardando" class="keep-icon-upright" slot="actions" color="primary" @click.stop="borrarConfiguracionPromo(false,'venta', true)">delete</v-icon>
        <div slot="header">
          <o-medium-title>{{$t('reservaSimplificada.ventasimplificada')}}</o-medium-title>
           
        </div>
        <v-card>
          <v-container fluid>
            <ConfiguracionReservaSimplificada
            :codigoPromocion="promocion ? promocion.codigo : null"
              :alquiler="false"
              @cambiado="cambiadoVentaSimp = $event"
              :borradoDeFuera="borradoVentaFueraSimp"
              @resetBorrado="borradoVentaFueraSimp = false"
            />
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel 
      expand 
      v-model="expandAlquiler"
      class="mt-4"
    >
      <v-expansion-panel-content
        :key="'alquiler'"
      >
        <v-icon slot="actions" color="primary">keyboard_arrow_down</v-icon>
        <v-icon v-if="promocion && modulosOrdenStore.some(x => x.simplificada == 0 && x.alquiler)" :loading="guardando" class="keep-icon-upright" slot="actions" color="primary" @click.stop="borrarConfiguracionPromo(false,'alquiler', false)">delete</v-icon>
        <div slot="header">
          <o-medium-title>{{$t('pages.configuracion.alquiler')}}</o-medium-title>
        </div>
        <v-card>
          <v-container fluid>
            <ConfiguracionReserva
            :codigoPromocion="promocion ? promocion.codigo : null"
              :alquiler="true"
              @cambiado="cambiadoAlquilerExt = $event"
              :borradoDeFuera="borradoAlquilerFueraExt"
              @resetBorrado="borradoAlquilerFueraExt = false"
            />
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel 
      expand 
      v-model="expandAlquilerSimplficado"
      class="mt-4"
    >
      <v-expansion-panel-content
        :key="'alquiler'"
      >

        <v-icon slot="actions" color="primary">keyboard_arrow_down</v-icon>
        <v-icon v-if="promocion && modulosOrdenStore.some(x => x.simplificada == 1 && x.alquiler)" :loading="guardando" class="keep-icon-upright" slot="actions" color="primary" @click.stop="borrarConfiguracionPromo(false,'alquiler', true)">delete</v-icon>
        <div slot="header">
          <o-medium-title>{{$t('reservaSimplificada.alguilersimplificado')}}</o-medium-title>
        </div>
        <v-card>
          <v-container fluid>
            <ConfiguracionReservaSimplificada
            :codigoPromocion="promocion ? promocion.codigo : null"
              :alquiler="true"
              @cambiado="cambiadoAlquilerSimp = $event"
              :borradoDeFuera="borradoAlquilerFueraSimp"
              @resetBorrado="borradoAlquilerFueraSimp = false"
            />
          </v-container>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
  <v-fade-transition>
      <PopUpSeguro
        v-if="mostrarBorrar"
        @aceptar="$event ? borrarConfiguracionPromo(true, tipoBorrado): mostrarBorrar = false"
        :titulo="$t('reservaSimplificada.borrarConfiguracionTitulo')"
        :alerta="$t('general.popUpSeguro.alertaIrreversible')"
        :pregunta="$t('reservaSimplificada.borrarConfiguracionTexto')"
        :descartar="$t('general.misc.eliminar')"
        :cancelar="$t('general.popUpSeguro.cancelar')"
      />
    </v-fade-transition>
  </page-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ConfiguracionReserva from '@/components/configuracion/ConfiguracionReserva'
import ConfiguracionReservaSimplificada from '@/components/configuracion/ConfiguracionReservaSimplificada'
import FileUploader from '@/components/generic/fileUploader/FileUploader'
import PopUpSeguro from '@/components/generic/PopUpSeguro'
import rulesMixin from '@/mixins/rules.js'

export default {
  props: ['promocion'],
  mixins: [rulesMixin],
  components: {
    ConfiguracionReserva, FileUploader, ConfiguracionReservaSimplificada, PopUpSeguro
  },
  data () {
    return {
      loading: true,
      iniciarVentaExt: false,
      iniciarVentaSimp: true,
      iniciarAlquilerExt: false,
      iniciarConPreguntaAlquiler: false,
      borrarSimplificada: null,
      iniciarConPreguntaVenta: false,
      iniciarAlquilerSimp: true,
      valid: true,
      guardando: false,
      guardandoGeneral: false,
      cambiadoGeneral: false,
      tipoBorrado: null,
      borradoAlquilerFueraSimp: false,
      borradoVentaFueraSimp: false,
      borradoAlquilerFueraExt: false,
      borradoVentaFueraExt: false,
      mostrarBorrar: false,
      cambiadoAlquilerExt: false,
      cambiadoVentaExt: false,
      cambiadoAlquilerSimp: false,
      cambiadoVentaSimp: false,
      otp: false,
      imagenCorreos: [],
      expandGeneral: [true],
      expandVenta: [false],
      expandAlquiler: [false],
      expandVentaSimplificada: [false],
      expandAlquilerSimplficado: [false]
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  async created () {
    try {
      await Promise.all([
        this.loadOtp(),
        this.loadImagenCorreos(),
        this.loadModulosActuales(this.promocion ? this.promocion.codigo : -1)
      ])
      let variables = await this.loadInicios(this.promocion ? this.promocion.codigo : -1)
      this.otp = this.otpObject.valor
      if (this.promocion) {
        this.iniciarConPreguntaAlquiler = variables.alquiler ? variables.alquiler.valor == 'N' && variables.alquiler.codigoPromocion == this.promocion.codigo : false
        this.iniciarConPreguntaVenta = variables.venta ? variables.venta.valor == 'N' && variables.venta.codigoPromocion == this.promocion.codigo :  false
        this.iniciarVentaExt = variables.venta ? variables.venta.valor == 'E' && variables.venta.codigoPromocion == this.promocion.codigo :  false
        this.iniciarVentaSimp = variables.venta ? variables.venta.valor == 'S' && variables.venta.codigoPromocion == this.promocion.codigo : false
        this.iniciarAlquilerExt = variables.alquiler ? variables.alquiler.valor == 'E'&& variables.alquiler.codigoPromocion == this.promocion.codigo : false
        this.iniciarAlquilerSimp = variables.alquiler  ? variables.alquiler.valor == 'S' && variables.alquiler.codigoPromocion == this.promocion.codigo : false
      } else {
        this.iniciarConPreguntaAlquiler = variables.alquiler ? variables.alquiler.valor == 'N' : false
        this.iniciarConPreguntaVenta = variables.venta ? variables.venta.valor == 'N' :  false
        this.iniciarVentaExt = variables.venta ? variables.venta.valor == 'E' : this.promocion == null
        this.iniciarVentaSimp = variables.venta ? variables.venta.valor == 'S' : false
        this.iniciarAlquilerExt = variables.alquiler ? variables.alquiler.valor == 'E' : this.promocion == null
        this.iniciarAlquilerSimp = variables.alquiler  ? variables.alquiler.valor == 'S' : false
      }
     
      this.imagenCorreos = (this.getImagenCorreos == null ? [] : [this.getImagenCorreos])
      this.$nextTick(() => {
        this.cambiadoGeneral = false
        this.loading = false
      })
    } catch (error) {
      if (!error.code || (error.code !== 1 && error.code !== 5)) {
        this.addAlert({texto: error.message, color: 'error'})
      } else if (error.code === 5) {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters({
      getVariableConfiguracion: 'configuracion/variablesConfiguracion/getById',
      usuario: 'login/usuario',
      modulosOrdenStore: 'modulosOrdenes/getAll',
      getImagenCorreos: 'configuracion/variablesConfiguracion/getImagenCorreos'
    }),
    breadcrumbs () {
      if (this.promocion) {
        return [
          {
            text: this.$t('pages.home'),
            exact: true,
            to: {name: 'home'}
          },
          {
            text: this.$t('pages.configuracion.configuracion'),
            exact: true,
            to: {name: 'configuracion'}
          },
          {
            text: this.$t('reservaSimplificada.breadcrumb'),
            exact: true,
            to: {name: 'configuracion.promociones'}
          },
          {
            text: this.promocion.descripcion,
            disabled: true,
          }
        ]
      } else {
        return [
          {
            text: this.$t('pages.home'),
            exact: true,
            to: {name: 'home'}
          },
          {
            text: this.$t('pages.configuracion.configuracion'),
            exact: true,
            to: {name: 'configuracion'}
          },
          {
            text: this.$t('pages.configuracion.generalMinuscula'),
            disabled: true
          }
        ]
      }
      
    },
    inicioVenta () {
      if (this.iniciarConPreguntaVenta) {
        return 'N'
      } else if (this.iniciarVentaExt) {
        return 'E'
      } else if (this.iniciarVentaSimp){
        return 'S'
      } else {
        return 'Q'
      }
    },
    inicioAlquiler () {
      if (this.iniciarConPreguntaAlquiler) {
        return 'N'
      } else if (this.iniciarAlquilerExt) {
        return 'E'
      } else if (this.iniciarAlquilerSimp) {
        return 'S'
      } else {
        return 'Q'
      }
    },
    cambiado () {
      return this.cambiadoGeneral || this.cambiadoAlquilerExt || this.cambiadoVentaExt || this.cambiadoAlquilerSimp || this.cambiadoVentaSimp
    },
    otpObject () {
      const obj = this.getVariableConfiguracion('VD_OTP_ACTIVADO')
      return {
        valor: obj.valor === 'S',
        descripcion: obj.descripcionClave
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.cambiado) {
      let respuesta = confirm(this.$t('general.misc.alertPreRefresh'))
      if (respuesta) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  methods: {
    ...mapActions({
      loadOtp: 'configuracion/variablesConfiguracion/loadOtp',
      loadInicios: 'configuracion/variablesConfiguracion/loadIniciosProcesos',
      modificarOtp: 'configuracion/variablesConfiguracion/modificarOtp',
      borrarModulosOrden: 'modulosOrdenes/borrar',
      loadPromociones: 'promociones/loadAll',
      loadImagenCorreos: 'configuracion/variablesConfiguracion/loadImagenCorreos',
      modificarImagenCorreos: 'configuracion/variablesConfiguracion/modificarImagenCorreos',
      loadModulosActuales: 'modulosOrdenes/loadActuales',
      addAlert: 'alerts/add'
    }),
    async guardarVariablesConfiguracion () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        this.guardandoGeneral = true
        let promesas = []
        if (this.otp !== this.otpObject.valor) {
          promesas.push(this.modificarOtp(this.otp))
        }
        promesas.push(this.modificarImagenCorreos({
          imagen: this.imagenCorreos.length === 0 ? null : this.imagenCorreos[0],
          inicioVenta: this.inicioVenta,
          inicioAlquiler: this.inicioAlquiler,
          codigoPromocion: this.promocion ? this.promocion.codigo : -1
        }))
        if (promesas.length > 0) {
          await Promise.all(promesas)
        }
        this.otp = this.otpObject.valor
        this.imagenCorreos = this.getImagenCorreos == null ? [] : [this.getImagenCorreos]
        this.$nextTick(() => {
          this.guardandoGeneral = false
          this.cambiadoGeneral = false
          this.addAlert({texto: this.$t('general.misc.datosGuardadosExito'), color: 'success'})
        })
      } catch (error) {
        this.addAlert({texto: error.message, color: 'error'})
        this.guardandoGeneral = false
      }
    },
    async borrarConfiguracionPromo (confirmado, tipo, simplificada) {
      
      if (!confirmado) {
        this.tipoBorrado = tipo
        this.mostrarBorrar = true
        this.borrarSimplificada = simplificada
        return
      }
      this.mostrarBorrar = false
      try {
        this.guardando = true
        const objetoParaApi = {
          alquiler: this.tipoBorrado == 'alquiler',
          simplificada: this.borrarSimplificada,
          codigoPromocion: this.promocion.codigo
        }
        await this.borrarModulosOrden(objetoParaApi)
        await this.loadModulosActuales(this.promocion ? this.promocion.codigo : -1)
        await this.loadPromociones(this.usuario.id)
        console.log(this.tipoBorrado)
        if (this.tipoBorrado == 'alquiler') {
          if (this.borrarSimplificada) {
            this.borradoAlquilerFueraSimp = true
            this.cambiadoAlquilerSimp = false
          } else {
            this.borradoAlquilerFueraExt = true
            this.cambiadoAlquilerExt = false
          }
          
        } else {
          if (this.borrarSimplificada) {
            this.borradoVentaFueraSimp = true
            this.cambiadoVentaSimp = false
          } else {
            this.borradoVentaFueraExt = true
            this.cambiadoVentaExt = false
          }
        }
        this.guardando = false
        this.borrarSimplificada = null
        this.addAlert({texto: this.$t('reservaSimplificada.configuracionBorrada'), color: 'success'})
      } catch (error) {
        this.guardando = false
        this.borrarSimplificada = null
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    }
  },
  watch: {
    imagenCorreos () {
      if (!this.loading) {
        this.cambiadoGeneral = true
      }
    },
    iniciarVentaExt (newValue) {
      if (newValue) {
        this.iniciarVentaSimp = false
        this.iniciarConPreguntaVenta = false
      }
      this.cambiadoGeneral = true
    },
    iniciarVentaSimp (newValue) {
      if (newValue) {
        this.iniciarVentaExt = false
        this.iniciarConPreguntaVenta = false
      }
      this.cambiadoGeneral = true
    },
    iniciarAlquilerExt (newValue) {
      if (newValue) {
        this.iniciarAlquilerSimp = false
        this.iniciarConPreguntaAlquiler = false
      }
      this.cambiadoGeneral = true
    },
    iniciarAlquilerSimp (newValue) {
      if (newValue) {
        this.iniciarAlquilerExt = false
        this.iniciarConPreguntaAlquiler = false
      }
      this.cambiadoGeneral = true
    },
    iniciarConPreguntaAlquiler (newValue) {
      if (newValue) {
        this.iniciarAlquilerExt = false
        this.iniciarAlquilerSimp = false
      }
      this.cambiadoGeneral = true
    },
    iniciarConPreguntaVenta (newValue) {
      if (newValue) {
        this.iniciarVentaExt = false
        this.iniciarVentaSimp = false
      }
      this.cambiadoGeneral = true
    }
  }
}
</script>
<style lang="stylus" scoped>

.keep-icon-upright
  transform: unset!important;

</style>



// WEBPACK FOOTER //
// src/pages/configuracion/configuracionGeneral.vue